import React from "react";
import { useFieldArray } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import styles from "./Keywords2.module.css";

export default function Fields({ control, register }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "keywords",
  });

  return (
    <div className="form-wrapper">
      <ul className={styles["keywords-list"]}>
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-container">
                  <div className={styles["keywords-form-wrapper"]}>
                    <InputFieldFormArray
                      label="Keyword "
                      fieldRef={register(`keywords[${index}].value`, {})}
                      name={`keywords[${index}].value`}
                      key={item.id}
                    />
                    <button
                      className="keywords-button delete-button small"
                      type="button"
                      onClick={() => {
                        remove(index);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      <section>
        <p className="message">
          Please fill in only one keyword in each field. The words included in
          the title of the specsheets don't have to be added.
        </p>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append();
          }}
        >
          Add Keyword
        </button>
      </section>
    </div>
  );
}
